<template lang="html">
  <div class="refunds" v-loading="fullLoading" style="margin-top: 28px;">
    <el-row :gutter="20">
  <el-col :span="6" style="padding-left: 28px;padding-right: 10px;">
    <div class="col-md2-4">
              <div class="form-group">
                <el-input v-model="condition.trxId" :placeholder="$t('Views.Refund.filter.trxId')" @keyup.native.enter="searchByCondition"></el-input>
              </div>
            </div>
  </el-col>
  <el-col :span="6">
    <div class="col-md2-4">
              <div class="form-group">
                <el-input v-model="condition.customer" :placeholder="$t('Views.Refund.filter.customer')" @keyup.native.enter="searchByCondition"></el-input>
              </div>
            </div>
  </el-col>
  <el-col :span="6">
    <div class="col-md2-4">
              <div class="form-group">
                <el-date-picker v-model="datePicker" type="datetimerange" :placeholder="$t('Date.placeholder')"></el-date-picker>
              </div>
            </div>

  </el-col>
  <el-col :span="6">
    <div class="col-md2-6 sm-margin">
              <div class="form-group">
                <sl-btn class="sl-btn-blue" :text="$t('Functional.confirm')" @click.native="searchByCondition"></sl-btn>
                <sl-btn class="sl-btn-blue" :text="$t('Functional.clear')" @click.native="clearSelectors"></sl-btn>
                <sl-btn v-if="!ContactBlockShow" :text="$t('Views.Refund.button.refund')" icon="sl-pending_refund" :disabled="!ContactBlockShow"></sl-btn>
                <sl-btn v-else :text="$t('Views.Refund.button.refund')" icon="sl-pending_refund" @click.native="onRefundDetail"></sl-btn>
              </div>
            </div>
  </el-col>
</el-row>
    <row>
      <div class="sl-col-4">
        <div class="sl-body" v-loading="loading">
          <row style="margin-bottom: 10px;position: relative;left: 19px;">
            <div class="col-md-12">
              <div class="form-group" style="float:right">
                <sl-btn :text="$t('Functional.download')" icon="sl-download" @click.native="download"></sl-btn>
              </div>
            </div>
          </row>
          <row class="sl-table-reload" v-show="reloadBtn">
            {{$t('Notify.errorMsg')}}
            <sl-btn class="sl-btn-lightblue" :text="$t('Functional.reload')" @click.native="reloadTable"></sl-btn>
          </row>
          <el-table :data="tableData" style="width: 100%" @sort-change="handleSortChange" border>
            <el-table-column min-width="200" :fixed="$store.state.userAgent.isPhone ? !true : true" :show-overflow-tooltip="true" prop="refundTime" :label="$t('Views.Refund.table.rTime')" sortable='custom'> </el-table-column>
            <el-table-column min-width="200" :show-overflow-tooltip="true" prop="trxId" :label="$t('Views.Refund.table.trxId')" sortable='custom'> </el-table-column>
            <el-table-column min-width="200" :show-overflow-tooltip="true" prop="refundAmount" :label="$t('Views.Refund.table.rAmount')" sortable='custom'> </el-table-column>
            <el-table-column min-width="200" :show-overflow-tooltip="true" prop="status" :label="$t('Views.Refund.table.rStatus')"> </el-table-column>
            <el-table-column min-width="200" :show-overflow-tooltip="true" prop="customer" :label="$t('Views.Refund.table.customer')">
              <template scope="scope">
                <img :src="`/static/imgs/T-${scope.row.channelId}.png`" alt="" style="width:20px;height:20px;">
                <span>{{ scope.row.customer }}</span>
              </template>
            </el-table-column>
            <el-table-column min-width="200" :show-overflow-tooltip="true" prop="description" :label="$t('Views.Refund.table.remark')"> </el-table-column>
            <el-table-column min-width="200" :show-overflow-tooltip="true" prop="outlet" :label="$t('Views.Refund.table.store')"> </el-table-column>
            <el-table-column min-width="200" :show-overflow-tooltip="true" prop="POSId" :label="$t('Views.Refund.table.posId')"> </el-table-column>
            <el-table-column :min-width="$store.state.userAgent.isPhone ? 100 : 200" fixed="right" :show-overflow-tooltip="true" :label="$t('Table.actions')">
              <template scope="scope">
                <el-button class="sl-detail" size="small" @click="gotoPage(scope.row.id)">{{$tc('Table.view',1)}}</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination small v-show="!reloadBtn" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="table.page" :page-sizes="[10, 20, 50, 100]" :page-size="table.per" layout=" prev, pager, next, sizes,jumper, total" :total="table.total"> </el-pagination>
        </div>
      </div>
    </row>
    <div class="sl-mask-confirm" v-show="ContactBlock">
      <div class="sl-block-contact">
        <i class="sl-block-icon" @click="ContactBlock = false">X</i>
        <p class="sl-block-title" style="padding-bottom: 10px;">{{$t('Views.Refund.mask.title')}}</p>
        <p class="sl-contact-cnt">{{$t('Views.Refund.mask.name')}}:
          <strong>{{tips.agencyName}}</strong>
        </p>
        <p class="sl-contact-cnt">{{$t('Views.Refund.mask.amount')}}:
          <strong>${{tips.refundTotal}}</strong>
        </p>
        <p class="sl-contact-cnt">{{$t('Views.Refund.mask.cnt')}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../api'
import * as types from '../../store/types'
import moment from '../../util/date'
export default {
  name: 'Refund',
  data() {
    return {
      fullLoading: false,
      conLoading: false,
      loading: false,
      ContactBlock: false,
      ContactBlockShow: true,
      tableData: [],
      table: this.$store.state.refunds.table,
      condition: this.$store.state.refunds.condition,
      datePicker: this.$store.state.refunds.datePicker,
      shopOptions: [],
      statusOptions: [],
      tips: {},
      reloadBtn: false
    }
  },
  methods: {
    gotoPage(id) {
      this.$ga.event('Link', 'Detail', 'Refunds')
      this.$router.push({
        name: 'Refund-Detail',
        params: {
          id: id
        }
      })
    },
    formatterDate(row, column) {
      return moment(row.createTime * 1000).format('L')
    },
    handleSizeChange(per) {
      this.table.per = per
      updateTable(this, initParams(this))
    },
    handleCurrentChange(page) {
      this.table.page = page
      updateTable(this, initParams(this))
    },
    handleSortChange({
      column,
      prop,
      order
    }) {
      this.table = {
        page: this.table.page,
        per: this.table.per,
        order: order === null ? '' : order === 'descending' ? 'DESC' : 'ASC',
        orderBy: prop === null ? '' : prop
      }
      updateTable(this, initParams(this))
    },
    clearSelectors() {
      this.$ga.event('Button', 'ClearAll', 'Refunds')
      this.condition = {
        trxId: '',
        customer: '',
        begin: '',
        end: ''
      }
      this.datePicker = []
    },
    searchByCondition() {
      this.$ga.event('Button', 'TableSearch', 'Refunds')
      updateTable(this, initParams(this))
    },
    download() {
      this.$ga.event('Button', 'Download', 'Refunds')
      const params = Object.assign({}, initParams(this))
      let st = ''
      for (let i in params) {
        if (params.hasOwnProperty(i)) {
          st = st + '&' + i + '=' + params[i]
        }
      }
      const url = '/client/refund?download=csv' + st
      window.open(url)
    },
    onRefundDetail() {
      this.$ga.event('Button', 'Pending refunds', 'Refunds')
      this.ContactBlock = true
    },
    reloadTable() {
      this.$ga.event('Button', 'Reload', 'Refunds')
      updateTable(this, initParams(this))
    }
  },
  created() {
    updateTable(this, initParams(this))
    const vm = this
    this.conLoading = true
    api.showRefundDetail().then(res => {
      if (res.data.code === 200) {
        vm.tips = res.data.data
        vm.ContactBlockShow = +vm.tips.refundTotal === 0 ? !true : true
      }
      vm.conLoading = false
    })
  },
  beforeRouteLeave(to, from, next) {
    if (to.name !== 'Refund-Detail') {
      this.$store.commit(types.InitRefundTable)
    }
    next()
  }
}
// 更新表单 。 默认每页10条，页码为1
function updateTable(vm, params) {
  vm.loading = true
  api.FetchRefundTable(params).then(res => {
    const result = res.data.data
    vm.table = {
      total: result.total,
      page: ~~result.page,
      per: ~~result.per,
      order: result.order,
      orderBy: result.orderBy
    }
    vm.tableData = result.list
    vm.reloadBtn = vm.loading = false
  }).catch(error => {
    console.log(error)
    vm.tableData = []
    vm.loading = false
    vm.reloadBtn = true
  })
}
// 初始化table请求接口的参数
function initParams(vm) {
  vm.$store.commit(types.SetRefundTable, {
    table: Object.assign({}, vm.table),
    condition: Object.assign({}, vm.condition),
    datePicker: vm.datePicker.map(item => item)
  })
  const ts = Object.assign({}, vm.$store.state.refunds)
  let tb = JSON.parse(JSON.stringify(ts.table))
  let cd = JSON.parse(JSON.stringify(ts.condition))
  delete tb.total
  if (ts.datePicker.length === 2) {
    cd.begin = ts.datePicker[0] === null ? '' : moment(ts.datePicker[0]).format('LT')
    cd.end = ts.datePicker[1] === null ? '' : moment(ts.datePicker[1]).format('LT')
  } else {
    delete cd.begin
    delete cd.end
  }
  return Object.assign({}, tb, cd)
}
</script>

<style>
.sl-mask-confirm {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.70);
  box-shadow: 1px 1px 3px 0 rgba(0, 0, 0, 0.10);
  border-radius: 2px;
  overflow-y: hidden;
  text-align: center;
}

.sl-block-title {
  font-family: Avenir-Book;
  font-size: 16px;
  color: #4A4A4A;
  line-height: 16px;
  padding-top: 30px;
}

.sl-block-contact {
  width: 380px;
  min-height: 204px;
  background: #FFFFFF;
  box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.10);
  border-radius: 2px;
  position: absolute;
  left: 50%;
  top: 10%;
  margin-left: -190px;
}

.sl-contact-cnt {
  font-family: Avenir-Book;
  font-size: 14px;
  color: #9B9B9B;
  line-height: 26px;
  max-width: 360px;
  margin: 0 auto;
}

.sl-contact-cnt strong {
  font-family: Avenir-Medium;
  font-size: 14px;
  color: #000000;
  line-height: 26px;
}

.sl-block-icon {
  position: absolute;
  right: 10px;
  top: 5px;
  font-family: Avenir-Book;
  font-size: 14px;
  color: #9B9B9B;
  cursor: pointer;
}

.refunds div.sl-body td .cell.el-tooltip {
  white-space: nowrap;
  word-break: break-all;
  text-overflow: ellipsis;
  width: 200px;
}

.refunds div.sl-body th .cell {
  white-space: nowrap;
  word-break: break-all;
  text-overflow: ellipsis;
  width: 200px;
}
</style>



// WEBPACK FOOTER //
// refunds.vue?5d245f35